import { http, HttpResponse, delay } from 'msw';

import { HardwareQuoteStatus } from '@electricjs/core_entity-client';

import {
  catalogShippingCost,
  confirmedOrder,
  orders,
  warehouseShippingCost,
} from '../data/orderData';
import { internalOrders } from '../data/orderManagementData';
import { quotes } from '../data/quoteData';

export const orderHandlers = [
  // orders (user-facing orders)
  http.get('*/v2/organizations/:id/procurements', async () => {
    await delay();
    return HttpResponse.json(
      { results: orders, total: orders.length },
      { status: 200 }
    );
  }),
  http.post('*/v2/organizations/:id/procurements', async () => {
    await delay();
    return HttpResponse.json(confirmedOrder, { status: 200 });
  }),
  http.post(
    '*/v2/organizations/:id/procurements/shipping_cost/calculate',
    async () => {
      await delay();
      return HttpResponse.json(catalogShippingCost, { status: 200 });
    }
  ),
  http.post(
    '*/v2/organizations/:id/procurements/warehouse_shipping/calculate',
    async () => {
      await delay();
      return HttpResponse.json(warehouseShippingCost, { status: 200 });
    }
  ),
  http.get(
    '*/v2/organizations/:id/procurements/:friendlyId',
    async ({ params }) => {
      const order = orders.find(
        order => order.friendly_id === params.friendlyId
      );

      if (order) {
        await delay();
        return HttpResponse.json(order, { status: 200 });
      } else {
        return new HttpResponse(null, { status: 404 });
      }
    }
  ),

  // internal orders
  http.get('*/v2/orders', async () => {
    await delay();
    return HttpResponse.json(
      { results: internalOrders, total: internalOrders.length },
      { status: 200 }
    );
  }),
  http.get('*/v2/orders/:friendlyId', async ({ params }) => {
    const order = internalOrders.find(
      order => order.friendly_id === params.friendlyId
    );

    if (order) {
      await delay();
      return HttpResponse.json(order, { status: 200 });
    } else {
      return new HttpResponse(null, { status: 404 });
    }
  }),

  http.patch('*/v2/orders/:friendlyId/line_items/:lineItemId', async () => {
    await delay();
    return new HttpResponse(null, { status: 204 });
  }),
  http.patch('*/v2/orders/:friendlyId/addresses', async () => {
    await delay();
    return new HttpResponse(null, { status: 204 });
  }),

  http.post('*/v2/orders/:friendlyId/cancel', async () => {
    await delay();
    return new HttpResponse(null, { status: 204 });
  }),

  // quotes
  http.get('*/v2/organizations/:id/quotes', async () => {
    await delay();
    return HttpResponse.json(
      { results: quotes, total: quotes.length },
      { status: 200 }
    );
  }),
  http.get('*/v2/organizations/:id/quotes/:friendlyId', async ({ params }) => {
    const quote = quotes.find(q => q.friendly_id === params.friendlyId);

    if (quote) {
      await delay();
      return HttpResponse.json(quote, { status: 200 });
    } else {
      return new HttpResponse(null, { status: 404 });
    }
  }),
  http.post('*/v2/organizations/:id/quotes', async () => {
    await delay();
    return HttpResponse.json(quotes[0], { status: 201 });
  }),
  http.post('*/v2/organizations/:id/quotes/:friendlyId/accept', async () => {
    await delay();
    return HttpResponse.json(
      quotes.find(quote => quote.status === HardwareQuoteStatus.Accepted),
      { status: 200 }
    );
  }),
  http.post('*/v2/organizations/:id/quotes/:friendlyId/reject', async () => {
    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
  http.post('*/v2/organizations/:id/quotes/:friendlyId/cancel', async () => {
    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
];
